<template lang="pug">
.back-order-detail.d-flex.flex-column.h-100
  .custom-header.d-flex.sticky-top
    //- CustomTab.flex-fill(
    //-   :tabItems='tabItems'
    //-   v-model='selectedTab'
    //- )
    button.transparent-button.ml-auto(@click='$emit(`closeButtonClicked`)')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

  Detail(
    :customer='customer'
    :backOrders='backOrders'
  )
  //- .text-medium {{ backOrders }}

  .d-flex.justify-content-center.mt-2.mb-4
    button.btn.btn-secondary.mr-3(@click='$emit(`closeButtonClicked`)')
      | ยกเลิก
    template(v-if='action === `CANCEL_ORDER`')
      button.btn.btn-upa-secondary.ml-3(
        @click='cancelBackOrder'
        :disabled='isCancellingBackOrder'
      )
        template(v-if='isCancellingBackOrder')
          LoadingIndicator
        template(v-else)
          | ยกเลิกรายการค้างส่ง

    template(v-else-if='action === `NEW_ORDER`')
      button.btn.btn-upa-secondary.ml-3(@click='$emit(`newOrderCreated`)')
        | สร้างรายการขาย
</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

import Detail from './_Detail.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    backOrders: {},
    action: {},
  },
  data: () => ({
    isCancellingBackOrder: false,
  }),
  components: {
    CustomerCompactDetailHeader,

    Detail,
  },
  methods: {
    async cancelBackOrder() {
      this.isCancellingBackOrder = true;

      // prepare the data
      const ordersToRemove = {};
      for (let i = 0; i < this.backOrders.length; i += 1) {
        const { id: orderId, productId } = this.backOrders[i];

        if (!ordersToRemove[orderId]) {
          ordersToRemove[orderId] = [];
        }
        ordersToRemove[orderId].push(productId);
      }
      // console.log(ordersToRemove);
      const allOrderIds = Object.keys(ordersToRemove);
      for (let i = 0; i < allOrderIds.length; i += 1) {
        const orderId = allOrderIds[i];
        const productIds = ordersToRemove[orderId];
        // console.log(orderId);
        // console.log(productIds);
        // console.log('');

        /* eslint-disable-next-line no-await-in-loop */
        const res = await this.$api.order.removeBackOrderItems(orderId, productIds);
        if (res.status === 200) {
          console.log(res);
        }
      }
      this.$emit('backOrderCancelled');
      this.isCancellingBackOrder = false;
    },
  },
};
</script>

<style lang="scss">
// .back-order-detail {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
